import React, { useState } from "react";
import * as styles from "./Badge.module.scss";
import classNames from "classnames";
import PropTypes from "prop-types";

const Badge = ({ label = "", className, dot = true, state, hint }) => {
	const [hovered, setHovered] = useState(false);
	const [toggled, setToggled] = useState(false);
	const showHint = !!hint && (hovered || toggled);
	const boxClassName = classNames(
		{
			[styles["badge"]]: true,
			[styles["has-hint"]]: !!hint,
			[className]: !!className,
		},
		state && styles["state"],
		styles[`state--${state}`],
	);

	return (
		<div
			className={boxClassName}
			onMouseEnter={() => setHovered(true)}
			onMouseLeave={() => {
				setHovered(false);
				setToggled(false);
			}}
			onClick={(event) => {
				event.stopPropagation();
				setToggled(!toggled);
			}}
		>
			{dot && <div className={styles["dot"]}></div>}
			<div>{label}</div>
			{showHint && <div className={styles["hint"]}>{hint}</div>}
		</div>
	);
};

Badge.propTypes = {
	label: PropTypes.string,
	className: PropTypes.string,
	dot: PropTypes.bool,
	state: PropTypes.string,
	hint: PropTypes.string,
};

export default Badge;
